/**
 * `/blog` and `/blog/:slug` — the editorial listing and one post, ON THIS HOST.
 *
 * **They used to be cross-host links to `shahedni.com`**, and that is the defect
 * these routes close rather than a preference about where a page lives. The
 * public host is a separate cookie scope by design — no parent-domain cookie
 * exists on this platform — so a subscriber who followed المقالات arrived in a
 * new tab with no session, and the post there could only offer them a sign-in
 * button for a session they already held. The catalogue's own browse surfaces
 * moved here first, for the same reason and with the same result.
 *
 * The segment is `slug` rather than an id: `backend-content` resolves the
 * editorial detail route on the slug, and the post's ULID — which every
 * engagement route is addressed by — comes back inside the payload.
 *
 * The two patterns are disjoint at their second segment, so the order here is
 * the sitemap's rather than the matcher's. Neither route has a `loader`: no
 * loader in this repo performs a data read, because a fetching loader creates a
 * cache TanStack Query does not know about and the two drift on every mutation.
 */
import type { RouteObject } from 'react-router-dom';

export const editorialRoutes: RouteObject[] = [
  {
    path: 'blog',
    lazy: async () => {
      const { EditorialPage } = await import('./index/EditorialPage');
      return { Component: EditorialPage };
    },
  },
  {
    path: 'blog/:slug',
    lazy: async () => {
      const { PostPage } = await import('./post/PostPage');
      return { Component: PostPage };
    },
  },
];
